import { put, call, takeLatest } from "redux-saga/effects";

import {
  getAllFaq$,
  getPrivacyPolicy$,
  getTermsAndConditions$
} from "../actions/cms";

import {
  getAllFaq,
  getPrivacyPolicy,
  getTermsAndConditions
} from "../../services/requestors/cms";

function* handleGetAllFaq() {
  try {
    yield put(getAllFaq$.request());
    const { data } = yield call(getAllFaq);
    let faq = data.data;
    let customfaq = [];
    if (faq.length > 0)
      for (let i = 0; i < faq.length; i++) {
        let newfaq = { ...faq[i], answer: decodeURIComponent(faq[i].answer) };
        customfaq.push(newfaq);
      }
    yield put(getAllFaq$.success(customfaq));
  } catch (error) {
    yield put(getAllFaq$.failure(error));
  } finally {
    yield put(getAllFaq$.fulfill());
  }
}

function* handleGetTermsAndConditions() {
  try {
    yield put(getTermsAndConditions$.request());
    const { data } = yield call(getTermsAndConditions);
    let terms_conditions = data.data;
    const decodedHtml = decodeURIComponent(terms_conditions.data);
    terms_conditions = { ...terms_conditions, data: decodedHtml };
    yield put(getTermsAndConditions$.success(terms_conditions));
  } catch (error) {
    yield put(getTermsAndConditions$.failure(error));
  } finally {
    yield put(getTermsAndConditions$.fulfill());
  }
}

function* handleGetPrivacyPolicy() {
  try {
    yield put(getPrivacyPolicy$.request());
    const { data } = yield call(getPrivacyPolicy);
    let privacy_policy = data.data;
    const decodedHtml = decodeURIComponent(privacy_policy.data);
    privacy_policy = { ...privacy_policy, data: decodedHtml };
    yield put(getPrivacyPolicy$.success(privacy_policy));
  } catch (error) {
    yield put(getPrivacyPolicy$.failure(error));
  } finally {
    yield put(getPrivacyPolicy$.fulfill());
  }
}

export default function* cmsWatcher() {
  yield takeLatest(getAllFaq$.TRIGGER, handleGetAllFaq);
  yield takeLatest(getTermsAndConditions$.TRIGGER, handleGetTermsAndConditions);
  yield takeLatest(getPrivacyPolicy$.TRIGGER, handleGetPrivacyPolicy);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/cms.js